import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  standalone: false,
  selector: 'campus-toc-header',
  templateUrl: './toc-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TocHeaderComponent {
  @HostBinding('class')
  defaultClasses = [
    'toc-header',
    'cluster',
    'cluster-space-m',
    'justify-center',
    'block',
    'p-b-s',
    'p-i-xs',
    'corner-l',
    'border',
    'border-primary',
    'primary-container',
  ];
}
